export default __webpack_public_path__ + "static/media/IconDesc_PlutoniumPellet.64.421cadd1.png";